import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";


const faqs = [
  {
    q: "What does Keymech do?",
    a: "We're an industrial product design agency for consumer electronics and IoT. We take products from concept to production-ready, industrial design, mechanical engineering, CAD, and electronics.",
  },

  {
    q: "Do you handle both the mechanical and electronic sides?",
    a: "Yes. mechanical design and enclosures plus electrical and PCB design, all in-house.",
  },

  {
    q: "Can you take my product from just an idea to a finished product?",
    a: "Yes. From first sketches through CAD, engineering, and production-ready files.",
  },

  {
    q: "Do you build real prototypes?",
    a: "Yes. real working prototypes, not just 3D models. We design and fabricate the PCBs, assemble the electronics, and integrate them with the enclosure so you get a functional unit to test before mass production.",
  },

  {
    q: "Do you design for IP ratings and industry standards?",
    a: "Yes. Whether you need a specific IP rating (like IP67) or compliance with industrial standards and your target country's regulations, we design for it from the start avoiding costly rework later.",
  },

  {
    q: "Will you help me find a manufacturer?",
    a: "Yes. We help you source the right manufacturers and prepare the documentation (CAD, specifications, and BOM) so factories can quote accurately.",
  },

  {
    q: "Do you support the move from design to production?",
    a: "Yes. We deliver production-ready files and offer manufacturing support to resolve design issues that come up during production.",
  },

  {
    q: "Is my idea safe with you?",
    a: "Completely. We'll sign an NDA before discussing anything, and full IP ownership and design files transfer to you upon project completion.",
  },

  {
    q: "How long does a project take?",
    a: "Usually a few weeks to a few months, depending on complexity. We provide a clear timeline once we understand your project scope.",
  },

  {
    q: "Do you work with international clients?",
    a: "Yes. we work with clients worldwide across different time zones.",
  },

  {
    q: "Can services be customized to my needs?",
    a: "Absolutely. Every engagement is scoped specifically to your product, development stage, and budget.",
  },

  {
    q: "How do I get started?",
    a: "Send us your idea or project requirements, and we'll arrange a discovery call to understand your goals and provide a tailored proposal.",
  },
];
export default function FAQ() {
  const [open, setOpen] = useState(null);
  const half = Math.ceil(faqs.length / 2);
  const left = faqs.slice(0, half);
  const right = faqs.slice(half);

  const Item = ({ faq, index }) => (
    <div className="border-b border-gray-100 py-4">
      <button
        className="max-w-full flex items-center justify-between text-left gap-4"
        onClick={() => setOpen(open === index ? null : index)}
      >
        <span className="font-medium text-dark text-sm">{faq.q}</span>
        <span className={`flex-shrink-0 w-6 h-6 rounded-full border-2 border-primary flex items-center justify-center transition-transform ${open === index ? "bg-primary" : ""}`}>
          <svg
            className={`w-3 h-3 transition-colors ${open === index ? "text-white" : "text-primary"}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3}
              d={open === index ? "M20 12H4" : "M12 4v16M4 12h16"}
            />
          </svg>
        </span>
      </button>
      <AnimatePresence>
        {open === index && (
          <motion.p
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="text-gray-500 text-sm mt-3 overflow-hidden"
          >
            {faq.a}
          </motion.p>
        )}
      </AnimatePresence>
    </div>
  );

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-[65rem] mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-xs font-semibold uppercase tracking-widest text-primary mb-3">↑ FAQ</p>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-dark">
            Frequently <span className="text-primary">Asked</span> Questions!
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-x-16">
          <div>{left.map((faq, i) => <Item key={i} faq={faq} index={i} />)}</div>
          <div>{right.map((faq, i) => <Item key={i + half} faq={faq} index={i + half} />)}</div>
        </div>
      </div>
    </section>
  );
}
